import React, { type FC } from 'react';

interface Props {
  isLoading: boolean;
  message?: string;
}

const Loading: FC<Props> = ({
  isLoading,
  message = 'Loading...',
}: Props) =>
  isLoading ? <div className="blinker blinker-lg w-100">{message}</div> : null;

export default Loading;
